import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import { HTMLContent } from '../components/Content';
import { ContactForm } from '../views/contact-form';
import { Contacts } from '../components/contacts';

export default ({ data }) => {
  const { markdownRemark: post } = data;

  const title = post.frontmatter.title;
  const html = post.html;

  return (
    <Layout title={title}>
      <section className="section">
        <div className="container">
          <h1 className="title is-1 has-text-centered">{title}</h1>
          <div className="columns">
            <div className="column">
              <Contacts />
              <HTMLContent className="content" content={html} />
            </div>
            <div className="column">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export const contactsFirstArticleQuery = graphql`
  query ContactsFirstArticle($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
      }
    }
  }
`;
